import DM from 'DM';

/**
 * Przeniesione z main.js i mobile/tr.js do jednego miejsca.
 */

var partner = DM.Utils.getParameterByName('utm_medium');
var source = DM.Utils.getParameterByName('utm_source');
var gclid = DM.Utils.getParameterByName('gclid');

var adwords = '';
var referrer = document.referrer.match(/^https?:\/\/([^\/]+\.)?domodi\.pl(\/|$)/i);

if (partner) {
    DM.Utils.setCookie('Partner', partner);
}

if (gclid) {
    adwords = 'adwords';
}

// TODO: Visits.cs przekazuje dalej do sklepów informacje, które są
// w cookie referrer (metoda: Visits, parametr visitSourceType)
if (DM.Utils.getCookie('referrer') !== null || (referrer !== null && (adwords === 'adwords' || source === 'Criteo'))) {
    var ref = [partner, adwords, document.referrer, source].join(',');
    var expire = new Date();
    expire.setTime(expire.getTime() + 1200000); // 20 min
    document.cookie = 'referrer' + '=' + encodeURIComponent(ref) + '; expires=' + expire + '; path=/';
}
